"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _actions = require("egov-ui-kit/redux/common/actions");

var _actions2 = require("egov-ui-kit/redux/form/actions");

var _api = require("egov-ui-framework/ui-utils/api");

var _actions3 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _actions4 = require("egov-ui-kit/redux/app/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "taxCalculation",
  fields: {
    propsedQTR: {
      id: "propsedQTR",
      jsonPath: "Properties[0].taxdetails.propsedQTR",
      required: true,
      localePrefix: true,
      labelsFromLocalisation: true,
      type: "singleValueList",
      floatingLabelText: "Proposed QTR",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      fullWidth: true,
      hintText: "PT_COMMONS_SELECT_PLACEHOLDER",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },

      updateDependentFields: function updateDependentFields(_ref) {
        //     dispatch(prepareFormData("Properties[0].tenantId", field.value));
        //     dispatch(
        //       prepareFormData(
        //         "Properties[0].taxdetails.ward",
        //         filter(get(state, "common.cities"), (ward) => {
        //           return ward.code === field.value;
        //         })[0].name
        //       )
        //     );
        //     dispatch(setFieldProperty("registrationDetails", "mohalla", "value", ""));
        //     const moduleValue = field.value;
        //     dispatch(fetchLocalizationLabel(getLocale(), moduleValue, moduleValue));
        //     let requestBody = generalMDMSDataRequestObj(field.value);
        //     dispatch(
        //       fetchGeneralMDMSData(requestBody, "PropertyTax", getGeneralMDMSDataDropdownName())
        //     );
        //   },

        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;
      }
    },
    propsedYear: {
      id: "propsedYear",
      type: "number",
      jsonPath: "Properties[0].taxdetails.propsedYear",
      floatingLabelText: "Proposed Year",
      numcols: 6,
      required: true,
      errorMessage: "Enter valid year",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      pattern: "^[12][0-9]{3}$"
    },
    rrMonth: {
      id: "rrMonth",
      type: "number",
      jsonPath: "Properties[0].taxdetails.rrMonth",
      floatingLabelText: "Reasonable Rent/Month",
      numcols: 6,
      required: true,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 }
    },

    AV: {
      id: "AV",
      type: "number",
      jsonPath: "Properties[0].taxdetails.AV",
      floatingLabelText: "AV",
      numcols: 3,
      required: true,
      disabled: true,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      gridDefination: {
        xs: 4,
        sm: 4
      }
    },
    testButton: {
      id: "testButton",
      type: "button",
      onClickFunc: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(state, dispatch) {
          var propsedYearData, propsedQTRData, premiseTypeData, rrMonthData, payloadResponse, payload;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  propsedYearData = (0, _get2.default)(state, "form.taxCalculation.fields.propsedYear.value", "");
                  propsedQTRData = (0, _get2.default)(state, "form.taxCalculation.fields.propsedQTR.value", "");
                  premiseTypeData = (0, _get2.default)(state, "form.propertyAddress.fields.premisesType.value", "");
                  rrMonthData = (0, _get2.default)(state, "form.taxCalculation.fields.rrMonth.value", "");
                  payloadResponse = {};
                  // dispatch(toggleSnackbarAndSetText(true, { labelName: "clicked", labelKey: "clicked" }, "error"));

                  if (!(propsedQTRData && propsedYearData)) {
                    _context.next = 67;
                    break;
                  }

                  if (!(parseInt(propsedYearData) > 2016)) {
                    _context.next = 24;
                    break;
                  }

                  dispatch((0, _actions4.toggleSnackbarAndSetText)(true, { labelName: "No Tax", labelKey: "No Tax" }, "error"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "commRate", "value", "0"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "howrghBridge", "value", "0"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "taxQtr", "value", "0"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "surcharge", "value", "0"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "payableAmount", "value", "0"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "rebateAmount", "value", "0"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "netAmount", "value", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.commRate", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.howrghBridge", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.taxQtr", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.surcharge", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.payableAmount", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.rebateAmount", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.netAmount", "0"));
                  _context.next = 65;
                  break;

                case 24:
                  _context.prev = 24;
                  _context.next = 27;
                  return (0, _api.httpRequest)("post", "property-services/property/_calculateArvTax", "", [], {
                    taxDetails: {
                      quarter: parseInt(propsedQTRData),
                      proposedQtr: parseInt(propsedYearData),
                      reasonableRent: parseInt(rrMonthData),
                      premisesType: premiseTypeData
                    }
                  });

                case 27:
                  payload = _context.sent;

                  payloadResponse = payload;

                  dispatch((0, _actions3.prepareFinalObject)("taxDetailsResponse", payloadResponse.taxDetails));

                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails", (0, _get2.default)(payloadResponse, "taxDetails", {})));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "commAV", "disabled", false));

                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "commRate", "value", payloadResponse.taxDetails.commRate));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "AV", "value", payloadResponse.taxDetails.av));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "commAV", "value", 0));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "howrghBridge", "value", payloadResponse.taxDetails.hbtAmount));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "taxQtr", "value", payloadResponse.taxDetails.quarter));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "surcharge", "value", payloadResponse.taxDetails.surcharge));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "payableAmount", "value", payloadResponse.taxDetails.paybleAmount));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "rebateAmount", "value", payloadResponse.taxDetails.rebateAmount));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "netAmount", "value", payloadResponse.taxDetails.netAmount));

                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.commRate", payloadResponse.taxDetails.commRate));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.commAv", 0));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.AV", payloadResponse.taxDetails.av));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.howrghBridge", payloadResponse.taxDetails.hbtAmount));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.taxQtr", payloadResponse.taxDetails.quarter));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.surcharge", payloadResponse.taxDetails.surcharge));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.payableAmount", payloadResponse.taxDetails.paybleAmount));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.rebateAmount", payloadResponse.taxDetails.rebateAmount));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.netAmount", payloadResponse.taxDetails.netAmount));

                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.commRate", payloadResponse.taxDetails.commRate));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.AV", payloadResponse.taxDetails.av ? payloadResponse.taxDetails.av : 0));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.commAv", 0));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.howrghBridge", payloadResponse.taxDetails.hbtAmount));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.taxQtr", payloadResponse.taxDetails.quarter));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.surcharge", payloadResponse.taxDetails.surcharge));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.payableAmount", payloadResponse.taxDetails.paybleAmount));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.rebateAmount", payloadResponse.taxDetails.rebateAmount));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.netAmount", payloadResponse.taxDetails.netAmount));

                  return _context.abrupt("return", payload);

                case 62:
                  _context.prev = 62;
                  _context.t0 = _context["catch"](24);

                  console.log(_context.t0);

                case 65:
                  _context.next = 68;
                  break;

                case 67:
                  dispatch((0, _actions4.toggleSnackbarAndSetText)(true, { labelName: "Please enter Proposed QTR and Proposed Year", labelKey: "Please enter Proposed QTR and Proposed Year" }, "error"));

                case 68:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, undefined, [[24, 62]]);
        }));

        return function onClickFunc(_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }(),
      label: "Calculate AV",
      buttonType: true,
      numcols: 3,
      gridDefination: {
        xs: 2,
        sm: 2
      }
    },

    commAV: {
      id: "commAV",
      type: "number",
      jsonPath: "Properties[0].taxdetails.commAv",
      floatingLabelText: "Commercial AV",
      numcols: 6,
      required: true,
      disabled: true,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 }
    },
    commRate: {
      id: "commRate",
      type: "number",
      jsonPath: "Properties[0].taxdetails.commRate",
      floatingLabelText: "Comm Rate",
      numcols: 6,
      disabled: true,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 }
    },
    howrghBridge: {
      id: "howrghBridge",
      type: "number",
      jsonPath: "Properties[0].taxdetails.howrghBridge",
      floatingLabelText: "Howrah Bridge",
      numcols: 6,
      disabled: true,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 }
    },
    taxQtr: {
      id: "taxQtr",
      type: "number",
      disabled: true,
      jsonPath: "Properties[0].taxdetails.taxQtr",
      floatingLabelText: "Tax/Qtr",
      numcols: 6,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 }
    },
    surcharge: {
      id: "surcharge",
      type: "number",
      disabled: true,
      jsonPath: "Properties[0].taxdetails.surcharge",
      floatingLabelText: "Surcharge",
      numcols: 6,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 }
    },
    payableAmount: {
      id: "payableAmount",
      type: "number",
      disabled: true,
      jsonPath: "Properties[0].taxdetails.payableAmount",
      floatingLabelText: "Payable Amount",
      numcols: 6,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 }
    },
    rebateAmount: {
      id: "rebateAmount",
      type: "number",
      disabled: true,
      jsonPath: "Properties[0].taxdetails.rebateAmount",
      floatingLabelText: "Rebate Amount",
      numcols: 6,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 }
    },
    netAmount: {
      id: "netAmount",
      type: "number",
      disabled: true,
      jsonPath: "Properties[0].taxdetails.netAmount",
      floatingLabelText: "Net Amount",
      numcols: 6,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 }
    }
  },
  afterInitForm: function afterInitForm(action, store, dispatch) {
    var propsedQTRDropDownData = [{
      name: "1",
      code: "1",
      label: "1",
      value: "1"
    }, {
      name: "2",
      code: "2",
      label: "2",
      value: "2"
    }, {
      name: "3",
      code: "3",
      label: "3",
      value: "3"
    }, {
      name: "4",
      code: "4",
      label: "4",
      value: "4"
    }];
    dispatch((0, _actions2.setFieldProperty)("taxCalculation", "propsedQTR", "dropDownData", propsedQTRDropDownData));
    return action;
  },

  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPay/taxCalculation.js
// module id = 1872
// module chunks = 1137